
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';

@Component
export default class SelectImagesModal extends Vue {
  visible = false;

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @Prop()
  wordTitleArray!: any[];

  @Prop()
  formData!: any;

  @Prop()
  headerImg: any;


  page = 1;

  lastPage = 0;

  loadType = false;

  lodoing = false;

  listFormData = [];

  wordTitle: any = '';

  activeKey: any = '';

  init() {
    this.visible = true;
    console.log(this.formData);
    this.getList(this.wordTitleArray[0]);
    this.activeKey = this.wordTitleArray[0]?.type;
    this.wordTitle = this.wordTitleArray[0];
    if (this.headerImg && this.headerImg.length > 0) {
      this.selectedDatas = this.headerImg.filter((x: any) => x !== null && typeof x === 'object');
      this.selectedKeys = this.headerImg.map((item: any) => item?.resource_id).filter((item: any) => item !== undefined);
    } else {
      this.selectedKeys = [];
      this.selectedDatas = [];
    }
    this.listFormData = this.formData[this.wordTitleArray[0]?.type]?.add || [];
  }

  async getList(data: any) {
    console.log(data);
    this.listFormData = this.formData[data?.type]?.add || [];
    const params = {
      status: 2,
      page: this.page,
      pageSize: 10,
    };
    if (data.id) {
      const res = await this.brandService.brandAlbumKaTemplateAlbum(data.id, params);
      this.lodoing = false;
      console.log(res);
      this.listData = [...this.listData, ...res.list];
      this.lastPage = res.lastPage;
      if (this.page < this.lastPage) {
        this.loadType = true;
      } else {
        this.loadType = false;
      }
    } else {
      this.loadType = false;
      this.listData = [];
    }
  }

  handleOk() {
    console.log(this.selectedKeys);
    const data = [...this.selectedDatas, ...new Array(5 - this.selectedDatas.length).fill(0)];
    this.visible = false;
    this.$emit('upload', data);
    this.handleCancel();
  }

  handleCancel() {
    this.visible = false;
    this.selectedKeys = [];
    this.selectedDatas = [];
    this.page = 1;
    this.listData = [];
    this.listFormData = [];
    this.wordTitle = '';
    this.loadType = false;
    this.lodoing = false;
  }

  callback(key: string) {
    this.activeKey = key;
    const res = this.wordTitleArray.find((item: any) => item.type === key);
    this.page = 1;
    this.listData = [];
    this.wordTitle = res;
    this.getList(res);
  }

  listData: any[] = [];

  // 已选中的 key 数组
  selectedKeys: string[] = [];

  selectedDatas: any[] = [];
  handleCheck(key: string, data: any): void {
    const index = this.selectedKeys.indexOf(key);
    if (index > -1) {
      // 已选中，取消
      this.selectedKeys.splice(index, 1);
      this.selectedDatas = this.selectedDatas.filter((item: any) => item.resource_id !== key);
    } else {
      // 未选中，加入
      if (this.selectedKeys.length >= 5) {
        this.$message.error('最多只能选择5张图片');
        return;
      }
      this.selectedKeys.push(key);
      this.selectedDatas.push(data);
    }
  }
  loadMore() {
    this.page++;
    this.lodoing = true;
    this.getList(this.wordTitle);
  }
}
